<ng-container
  *transloco="let t; prefix: 'widgets.grid-analytic-item-selector-dialog.taxonomy-config'"
  [formGroup]="form"
>
  <h4>{{ t('taxonomy') }}</h4>
  <div class="grid-taxonomoy-config__radios">
    <xi-radio
      formControlName="selectionType"
      name="selectionType"
      value="topItems"
      [label]="t('top-items')"
    ></xi-radio>
    <xi-radio
      formControlName="selectionType"
      name="selectionType"
      value="customItems"
      [label]="t('custom-items')"
    ></xi-radio>
  </div>
  @if (selectionType.value === 'topItems') {
    <div class="grid-taxonomy-config__top-items">
      <div class="grid-taxonomy-config__showing-top">
        <span>{{ t('showing-top') }}</span>
        <xi-input-field formControlName="numItems" type="number"></xi-input-field>
        <span>{{ t('items') }}</span>
      </div>

      <div class="grid-taxonomy-config__exclude">
        <span class="grid-taxonomy-config__exclude-label">{{ t('exclude') }}</span>
        <div class="grid-taxonomy-config__exclude-checkboxes" formGroupName="nodeOptions">
          <xi-checkbox formControlName="excludeLeafNodes" [label]="t('leaf-nodes')"></xi-checkbox>
          <xi-checkbox
            formControlName="excludeNonLeafNodes"
            [label]="t('non-leaf-nodes')"
          ></xi-checkbox>
        </div>
      </div>
    </div>
  } @else {
    <app-taxonomy-picker
      [selectMultiple]="true"
      [showUncategorized]="true"
      [showRevert]="false"
      [showDocumentCount]="true"
      [selectedNodeIds]="taxonomyPayload()?.customTaxonomyItems"
      [projectId]="projectId()"
      [widgetDataSource]="widgetDataSource()"
      (selectionChange)="onTaxonomySelectionChanged($event)"
    ></app-taxonomy-picker>
  }
</ng-container>
